"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _JoinButtonModule = _interopRequireDefault(require("./JoinButton.module.css"));

var staticImages = _interopRequireWildcard(require("../staticImages"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var JoinButton = /*#__PURE__*/function (_React$Component) {
  _inherits(JoinButton, _React$Component);

  var _super = _createSuper(JoinButton);

  function JoinButton(props) {
    var _this;

    _classCallCheck(this, JoinButton);

    _this = _super.call(this, props);
    _this.state = {
      type: ""
    };
    _this.handleNav = _this.handleNav.bind(_assertThisInitialized(_this));
    _this.getType = _this.getType.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(JoinButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getType();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.zoom !== this.props.zoom) {
        this.getType();
      }
    }
  }, {
    key: "getType",
    value: function getType() {
      if (this.props.zoom.toLowerCase().includes("zoom")) {
        this.setState({
          type: "zoom"
        });
      } else if (this.props.zoom.toLowerCase().includes("skype")) {
        this.setState({
          type: "skype"
        });
      } else if (this.props.zoom.toLowerCase().includes("teams") || this.props.zoom.toLowerCase().includes("microsoft")) {
        this.setState({
          type: "teams"
        });
      } else if (this.props.zoom.toLowerCase().includes("bluejeans")) {
        this.setState({
          type: "blue"
        });
      } else if (this.props.zoom.toLowerCase().includes("google") || this.props.zoom.toLowerCase().includes("meet")) {
        this.setState({
          type: "meet"
        });
      }
    }
  }, {
    key: "handleNav",
    value: function handleNav() {
      if (this.props.zoom === "") {
        this.props.errorPopup();
      } else {
        if (this.props.zoom.toLowerCase().includes("https://")) {
          window.open(this.props.zoom, "_blank");
        } else {
          window.open("https://".concat(this.props.zoom), "_blank");
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /*
      if((window.innerWidth >= 768 && window.innerWidth <= 1149) || (window.innerWidth < 470)) {
          switch(this.state.type) {
              case "zoom": 
                  return(
                          <div id={styles.small_button} style={{background: "#2fa2fd"}} onClick={() => {this.handleNav(); this.props.editMailingList();} }>
                              <div id={styles.small_join}>Join</div>
                              <img id={styles.zoom_icon} src={staticImages.ZOOM} alt="zoom icon" />
                          </div>
                  );    
              case "skype":
                  return(
                          <div id={styles.small_button} style={{background: "#13b5ff"}} onClick={() => {this.handleNav(); this.props.editMailingList();} }>
                              <div id={styles.small_join}>Join</div>
                              <img id={styles.skype_icon} src={staticImages.SKYPE} alt="skype icon" />
                          </div>
                  ); 
              case "teams":
                  return(
                          <div id={styles.small_button} style={{background: "#7583d4"}} onClick={() => {this.handleNav(); this.props.editMailingList();} }>
                              <div id={styles.small_join}>Join</div>
                              <img id={styles.teams_icon} src={staticImages.TEAMS} alt="teams icon" />
                          </div>
                  );
              case "blue":
                  return(    
                          <div id={styles.small_button} style={{background: "#3a9ddf"}} onClick={() => {this.handleNav(); this.props.editMailingList();} }>
                              <div id={styles.small_join}>Join</div>
                              <img id={styles.blue_icon} src={staticImages.BLUEJEANS} alt="bluejeans icon" />
                          </div>
                  ); 
              case "meet":
                  return(
                          <div id={styles.small_button} style={{background: "#0a9889"}} onClick={() => {this.handleNav(); this.props.editMailingList();} }>
                              <div id={styles.small_join}>Join</div>
                              <img id={styles.meet_icon} src={staticImages.MEET} alt="meet icon" />
                          </div>
                  );              
               }
          return(
              <div id={styles.small_button}>
                  <div id={styles.small_text}>Join Us</div>
              </div>
          );
      }
      */
      if (this.props.type === "large") {
        switch (this.state.type) {
          case "zoom":
            return /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].large_button,
              style: {
                background: "#2fa2fd"
              },
              onClick: function onClick() {
                _this2.handleNav();

                _this2.props.editMailingList();
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].inner_button
            }, /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].join
            }, "Join"), /*#__PURE__*/_react["default"].createElement("img", {
              id: _JoinButtonModule["default"].zoom_icon,
              src: staticImages.ZOOM,
              alt: "zoom icon"
            })));

          case "skype":
            return /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].large_button,
              style: {
                background: "#13b5ff"
              },
              onClick: function onClick() {
                _this2.handleNav();

                _this2.props.editMailingList();
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].inner_button
            }, /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].join
            }, "Join"), /*#__PURE__*/_react["default"].createElement("img", {
              id: _JoinButtonModule["default"].skype_icon,
              src: staticImages.SKYPE,
              alt: "skype icon"
            })));

          case "teams":
            return /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].large_button,
              style: {
                background: "#7583d4"
              },
              onClick: function onClick() {
                _this2.handleNav();

                _this2.props.editMailingList();
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].inner_button
            }, /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].join
            }, "Join"), /*#__PURE__*/_react["default"].createElement("img", {
              id: _JoinButtonModule["default"].teams_icon,
              src: staticImages.TEAMS,
              alt: "teams icon"
            })));

          case "blue":
            return /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].large_button,
              style: {
                background: "#3a9ddf"
              },
              onClick: function onClick() {
                _this2.handleNav();

                _this2.props.editMailingList();
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].inner_button
            }, /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].join
            }, "Join"), /*#__PURE__*/_react["default"].createElement("img", {
              id: _JoinButtonModule["default"].blue_icon,
              src: staticImages.BLUEJEANS,
              alt: "bluejeans icon"
            })));

          case "meet":
            return /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].large_button,
              style: {
                background: "#0a9889"
              },
              onClick: function onClick() {
                _this2.handleNav();

                _this2.props.editMailingList();
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].inner_button
            }, /*#__PURE__*/_react["default"].createElement("div", {
              id: _JoinButtonModule["default"].join
            }, "Join"), /*#__PURE__*/_react["default"].createElement("img", {
              id: _JoinButtonModule["default"].meet_icon,
              src: staticImages.MEET,
              alt: "meet icon"
            })));
        }

        return /*#__PURE__*/_react["default"].createElement("div", {
          id: _JoinButtonModule["default"].large_button,
          style: {
            background: "#4BB543"
          },
          onClick: function onClick() {
            _this2.handleNav();

            _this2.props.editMailingList();
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _JoinButtonModule["default"].inner_button,
          onClick: function onClick() {
            _this2.handleNav();

            _this2.props.editMailingList();
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _JoinButtonModule["default"].join_us
        }, "Join Us")));
      }

      switch (this.state.type) {
        case "zoom":
          return /*#__PURE__*/_react["default"].createElement("div", {
            id: _JoinButtonModule["default"].join_button,
            style: {
              background: "#2fa2fd",
              top: this.props.top
            },
            onClick: function onClick() {
              _this2.handleNav();

              _this2.props.editMailingList();
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            id: _JoinButtonModule["default"].join
          }, "Join"), /*#__PURE__*/_react["default"].createElement("img", {
            id: _JoinButtonModule["default"].zoom_icon,
            src: staticImages.ZOOM,
            alt: "zoom icon"
          }));

        case "skype":
          return /*#__PURE__*/_react["default"].createElement("div", {
            id: _JoinButtonModule["default"].join_button,
            style: {
              background: "#13b5ff",
              top: this.props.top
            },
            onClick: function onClick() {
              _this2.handleNav();

              _this2.props.editMailingList();
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            id: _JoinButtonModule["default"].join
          }, "Join"), /*#__PURE__*/_react["default"].createElement("img", {
            id: _JoinButtonModule["default"].skype_icon,
            src: staticImages.SKYPE,
            alt: "skype icon"
          }));

        case "teams":
          return /*#__PURE__*/_react["default"].createElement("div", {
            id: _JoinButtonModule["default"].join_button,
            style: {
              background: "#7583d4",
              top: this.props.top
            },
            onClick: function onClick() {
              _this2.handleNav();

              _this2.props.editMailingList();
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            id: _JoinButtonModule["default"].join
          }, "Join"), /*#__PURE__*/_react["default"].createElement("img", {
            id: _JoinButtonModule["default"].teams_icon,
            src: staticImages.TEAMS,
            alt: "teams icon"
          }));

        case "blue":
          return /*#__PURE__*/_react["default"].createElement("div", {
            id: _JoinButtonModule["default"].join_button,
            style: {
              background: "#3a9ddf",
              top: this.props.top
            },
            onClick: function onClick() {
              _this2.handleNav();

              _this2.props.editMailingList();
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            id: _JoinButtonModule["default"].join
          }, "Join"), /*#__PURE__*/_react["default"].createElement("img", {
            id: _JoinButtonModule["default"].blue_icon,
            src: staticImages.BLUEJEANS,
            alt: "bluejeans icon"
          }));

        case "meet":
          return /*#__PURE__*/_react["default"].createElement("div", {
            id: _JoinButtonModule["default"].join_button,
            style: {
              background: "#0a9889",
              top: this.props.top
            },
            onClick: function onClick() {
              _this2.handleNav();

              _this2.props.editMailingList();
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            id: _JoinButtonModule["default"].join
          }, "Join"), /*#__PURE__*/_react["default"].createElement("img", {
            id: _JoinButtonModule["default"].meet_icon,
            src: staticImages.MEET,
            alt: "meet icon"
          }));
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        id: _JoinButtonModule["default"].join_button,
        style: {
          top: this.props.top
        },
        onClick: function onClick() {
          _this2.handleNav();

          _this2.props.editMailingList();
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: _JoinButtonModule["default"].join_us
      }, "Join Us"));
    }
  }]);

  return JoinButton;
}(_react["default"].Component);

var _default = JoinButton;
exports["default"] = _default;

//# sourceMappingURL=JoinButton.js.map